import { UserType } from '@avanta/shared/constants/users';
import { type UserState, createUserSlice } from '@avanta/shared/stores/user';
import type { User } from '@avanta/shared/types/users';
import { create } from 'zustand';

interface PatientUserExtension {
  isPatient: boolean;
  isEmployee: boolean;
  isPsychologist: boolean;
  isSupporter: boolean;
}

type PatientUserState = UserState & PatientUserExtension;

export const useUserStore = create<PatientUserState>()((set, get, api) => ({
  ...createUserSlice<PatientUserState>()(set, get, api),
  isPatient: false,
  isEmployee: false,
  isPsychologist: false,
  isSupporter: false,
  setUser: (user: User): void => {
    set({
      user,
      isPatient: user?.type === UserType.PATIENT,
      isEmployee: user?.type === UserType.EMPLOYEE,
      isSupporter: user?.type === UserType.SUPPORTER,
      isPsychologist: user?.type === UserType.PSYCHOLOGIST,
    });
  },
}));

export const useIsPatientOrEmployee = (): boolean =>
  useUserStore(state => state.isPatient || state.isEmployee);

export const useIsPatient = (): boolean => useUserStore(state => state.isPatient);
export const useIsSupporter = (): boolean => useUserStore(state => state.isSupporter);
export const useIsPsychologist = (): boolean => useUserStore(state => state.isPsychologist);
